import { apiGet, apiPost } from '@/lib/http/client';

import type { MailchimpAudiencesResponse } from '../types';

export async function getMailchimpAudiences(
  orgId: number | string
): Promise<MailchimpAudiencesResponse> {
  return apiGet<MailchimpAudiencesResponse>(
    `/api/orgs/${orgId}/mailchimp/audiences/`
  );
}

export async function selectMailchimpAudience(
  orgId: number | string,
  audienceId: string
): Promise<{ success: boolean; audience_id: string; audience_name: string }> {
  return apiPost<{
    success: boolean;
    audience_id: string;
    audience_name: string;
  }>(`/api/orgs/${orgId}/mailchimp/select-audience/`, {
    audience_id: audienceId,
  });
}
